<template>
  <div>
    <a-table :data-source="feedbackList" :columns="columns" :pagination="pagination" :loading="loading" row-key="id" @change="handlePageChange">
      <template slot="currentTitle" slot-scope="text, record">
        <a-tooltip :title="record.title">
          <a class="custom-link" @click="showFeedbackDetail(record)">{{ record.title }}</a>
        </a-tooltip>
      </template>
      <template slot="type" slot-scope="text, record">
        <feedback-type-edit :disabled="false" :feedback-id="record.id" :type="record.type" @change="$emit('refresh')" />
      </template>
      <template slot="status" slot-scope="text, record">
        <feedback-status-edit :disabled="false" :feedback-id="record.id" :status="record.status" @change="$emit('refresh')" />
      </template>
      <template slot="commentCount" slot-scope="text, record">
        <a-tag v-if="record.comment_count > 0" color="blue">{{ record.comment_count }}</a-tag>
        <span v-else>--</span>
      </template>
      <template slot="creator" slot-scope="text, record">{{ record.creator.nickname }}</template>
    </a-table>

    <feedback-detail ref="feedbackDetail" @refresh="$emit('refresh')" />
  </div>
</template>

<script>
import FeedbackDetail from '@/pages/system/components/FeedbackDetail';
import FeedbackTypeEdit from '@/pages/feedback/components/FeedbackTypeEdit';
import FeedbackStatusEdit from '@/pages/feedback/components/FeedbackStatusEdit';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 60
  },
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    width: 320,
    ellipsis: true,
    scopedSlots: { customRender: 'currentTitle' }
  },
  {
    title: '反馈类型',
    dataIndex: 'type',
    key: 'type',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '评论数',
    dataIndex: 'comment_count',
    key: 'comment_count',
    width: 80,
    scopedSlots: { customRender: 'commentCount' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 120,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 170
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: 170
  }
];

export default {
  name: 'FeedbackList',
  components: {
    FeedbackDetail,
    FeedbackTypeEdit,
    FeedbackStatusEdit
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    feedbackList: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns
    };
  },
  methods: {
    handlePageChange(pagination) {
      this.$emit('page-change', pagination);
    },
    showFeedbackDetail(record) {
      this.$refs.feedbackDetail.open(record);
    }
  }
};
</script>

<style lang="less" scoped></style>
